import UserService from '@services/UserService';
import { Button, Icon, Upload } from 'antd';
import AWS from 'aws-sdk';
import React from 'react';

import I18n from '../i18n';
import styled from '../styled-components';

type PropType = {
  isRequired?: boolean;
  buttonTitle: string;
  customListType?: "picture" | 'picture-card' | 'text' | undefined;
  defaultFileList?: any;
  onFileListChange: Function;
  onValidate: Function;
  onRemoveImage: Function;
  typeFile?: string;
  validateType?: any;
  validateUpload?: any;
  isLoading?: any;
};

type StateType = {
  fileList: any[];
  containsExtension?: boolean;
  path: string;
  isLoading: boolean;
};

//let response = ''

export default class UploadModelComponent extends React.Component<PropType, StateType> {

  private _userService: UserService;

  constructor(props: PropType) {
    super(props);

    this.state = {
      fileList: props.defaultFileList || [],
      containsExtension: undefined,
      path: '',
      isLoading: false
    }

    this.onChange = this.onChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this._userService = new UserService();
  }

  componentDidMount() {
    if (this.props.onValidate) this.props.onValidate(this.validateField);
  }

  onChange = async (value: any) => {

    const storage = JSON.parse(localStorage.getItem('clientUpload') || '')

    const userAccessKey = await this._userService.getAccessAWS('s3');   

    AWS.config.update({
        accessKeyId: userAccessKey.AccessKeyId,
        secretAccessKey: userAccessKey.SecretAccessKey,
        sessionToken: userAccessKey.SessionToken
    });

    const s3 = new AWS.S3();
    const params = {
      ACL: 'public-read',
      Body: value.file,
      Bucket: `${storage.bucket}/public/3d`,
      ContentType: value.file.type,
      Key: `${Date.now().toString()}.fbx`
    };
    this.setState({ isLoading: value.file ? true : false })
    const response = await s3.upload(params).promise();

    this.setState({
      path: response.Location,
      isLoading: false
    })

    this.props.validateUpload(this.state.path)
    this.props.isLoading(this.state.isLoading)
  }

  onRemove() {
    this.props.onRemoveImage();
  }
  getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  validateField = (rule: any, value: any, callback: any) => {
    const { isRequired } = this.props;
    const { fileList } = this.state;

    if (isRequired) {
      if (fileList.length == 0) {
        callback(I18n.l('form.validation.image.required'));
        return;
      }
    }
    callback();
  }

  render() {
    const {
      customListType,
      buttonTitle
    } = this.props;

    const {
      fileList,
    } = this.state;


    const imgUploadBtnSpace = fileList.length > 0 ? "hide-btn-space" : "";
    const imgUploadBtnHidder = fileList.length > 0 ? "upload-img-hide" : "upload-img-show";

    const imagesProps = {
      action: '//jsonplaceholder.typicode.com/posts/',
      className: `upload-list-inline ${imgUploadBtnSpace}`,
      defaultFileList: this.props.defaultFileList,
      onRemove: (file: any) => {
        this.onRemove(),
          this.setState(({ fileList }) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            return {
              fileList: newFileList,
            };
          });
      },
      beforeUpload: (file: any) => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file],
        }));
        return false;
      },
    };

    return (
      <Wrapper>
        <Upload accept={this.props.typeFile} {...imagesProps} listType={customListType != undefined ? customListType : 'text'} onChange={this.onChange} >
          <Button className={`upload-btn ${imgUploadBtnHidder} `}>
            <Icon type="upload" /> {buttonTitle}
          </Button>
        </Upload>
        {this.state.isLoading && I18n.l('common.loadingData')}
        {this.state.containsExtension === false && this.state.fileList.length !== 0 &&
          <span className='validate-style'>{I18n.l('formflow.components.modelComponent.validateType')}</span>
        }
        {this.state.fileList.length === 0 &&
          <span className='validate-style'>{I18n.l('formflow.components.modelComponent.validateUpload')}</span>
        }
      </Wrapper>
    );
  }
}


const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    width: 100%;   

    .upload-btn{
        height: 45px;
        margin-top: 0px;
        border-style: dashed;
    }
    .validate-style{
      font-weight: bold;
      color: red;
    }

    .ant-upload-list-item-info{
        display:flex;
        align-items: center;
        height:100%;        
    }

    .ant-upload-list-picture .ant-upload-list-item-thumbnail, .ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
        top: 5px;
    }

    /* tile uploaded pictures */
    .upload-list-inline .ant-upload-list-item {
        float: left;
        width: 200px;
        margin-right: 8px;
        margin-top: 0px;
        width: 300px;
        height: 60px;        
    }
    .upload-list-inline .ant-upload-animate-enter {
        animation-name: uploadAnimateInlineIn;
    }
    .upload-list-inline .ant-upload-animate-leave {
        animation-name: uploadAnimateInlineOut;
    }    

    .hide-btn-space .ant-upload.ant-upload-select{
        display:none;   
    }    
    
    .upload-img-hide{
        display:none;
    }
    .upload-img-show{
        display:flex;
    }
`;
